import { Control, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactSelect from 'react-select';

import { DropdownIndicator } from 'coreOld/elements';

interface IProps {
  name: string;
  value?: string | number | string[] | number[];
  defaultValue?: string | number | string[] | number[];
  placeholder?: string;
  menuIsOpen?: boolean;
  control?: Control<FieldValues, object>;
  isMulti?: boolean;
  mapDataToFilters: (options, onChange) => void;
  customStyles?;
  getValue?;
  getLabel?;
  options?;
  isLoadingOptions?: boolean;
  onChange?;
  disabled?: boolean;
  editable?: boolean;
  onKeyDown?;
  isClearable?: boolean;
  autoFocus?: boolean;
}

const SelectView = ({
  name,
  defaultValue = null,
  customStyles,
  options,
  isLoadingOptions = false,
  onChange,
  value = null,
  placeholder,
  menuIsOpen,
  isMulti = false,
  getValue,
  getLabel,
  mapDataToFilters,
  disabled = false,
  editable = true,
  onKeyDown,
  isClearable = false,
  autoFocus = false,
}: IProps) => {
  const { t } = useTranslation();

  value = value || defaultValue;

  return (
    <ReactSelect
      name={name}
      components={{ DropdownIndicator }}
      styles={customStyles}
      defaultValue={defaultValue}
      onChange={(option) =>
        isMulti ? mapDataToFilters(option, onChange) : onChange(getValue(option))
      }
      options={options}
      value={value && options.find((option) => option.value === value)}
      getOptionValue={getValue}
      getOptionLabel={getLabel}
      noOptionsMessage={() =>
        isLoadingOptions ? t('messageLoading') : t('messageNoOptionsAvailable')
      }
      placeholder={placeholder}
      menuIsOpen={menuIsOpen}
      isMulti={isMulti}
      isDisabled={disabled && !editable}
      onKeyDown={(event) => onKeyDown && onKeyDown(event)}
      isClearable={isClearable}
      menuPortalTarget={document.body}
      autoFocus={autoFocus}
      closeMenuOnSelect
    />
  );
};

export default SelectView;
